export default __webpack_public_path__ + "static/media/shield-back.ae4b28e1.svg";